export default __webpack_public_path__ + "static/media/NRG_ΗΛ.af7d10fc.png";